import React from 'react';
import MainHeader from './pageHeader';
import TenantHeader from './tenant';

const PageHeader = (props) => {
  if (props?.isTenant) return <TenantHeader {...props} />;
  else return <MainHeader {...props} />;
};
export default PageHeader;
